import React, { FunctionComponent } from "react";
import { getClipPaths } from "../../../../utils/customization/clipping";

const ClippingPath: FunctionComponent<{
  contentSVG: string;
  id: string;
}> = ({ contentSVG, id }) => {
  const clipPaths = getClipPaths(contentSVG);

  return (
    <>
      {clipPaths && (
        <svg viewBox="0 0 1 1">
          <defs>
            <clipPath
              clipPathUnits="objectBoundingBox"
              dangerouslySetInnerHTML={{ __html: clipPaths }}
              id={id}
            />
          </defs>
        </svg>
      )}
    </>
  );
};

export default ClippingPath;
